"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TtlCache = void 0;
var angular_1 = require("angular");
var js_cache_1 = __importDefault(require("js-cache"));
var lodash_1 = __importDefault(require("lodash"));
var EXPIRING_KEY_SUFFIX = '__expirationKeySuffix__';
function getExpiringKey(originalKey) {
    return "" + originalKey + EXPIRING_KEY_SUFFIX;
}
function getOriginalKey(expiringKey) {
    return expiringKey.split(EXPIRING_KEY_SUFFIX)[0];
}
function isExpiringKey(key) {
    return lodash_1.default.endsWith(key, EXPIRING_KEY_SUFFIX);
}
var TtlCache = /** @class */ (function () {
    function TtlCache(options) {
        this.ttl = options.ttl;
        this.cache = new js_cache_1.default();
        this._setExpirationCallback(options.onExpiration);
    }
    /**
     * Every time we set a key, we need to set a corresponding expiring key.
     * We need an expiring key so that we can trigger the onExpiration callback when the key expires.
     * We cannot give the original key a ttl because the 'del' event
     * provided by js-cache is triggered on expiration AND calls to cache.del.
     * By placing a ttl on the corresponding expiring key, we can distinguish between
     * deletes due to expiration vs deletes due to calls to cache.del(). See _setExpirationCallback for more info.
     */
    TtlCache.prototype.set = function (key, value) {
        if (value === void 0) { value = null; }
        var expiringKey = getExpiringKey(key);
        this.cache.set(key, value);
        this.cache.set(expiringKey, true, this.ttl);
    };
    TtlCache.prototype.del = function (key) {
        var expiringKey = getExpiringKey(key);
        this.cache.del(key);
        this.cache.del(expiringKey);
    };
    TtlCache.prototype.clear = function () {
        this.cache.clear();
    };
    TtlCache.prototype.size = function () {
        return this.cache.size() / 2;
    };
    /**
     * We need to distinguish between 'del' events caused by expiration vs calls to cache.del()
     * If the 'del' is triggered for the expiring key, and the original key is still present,
     * then this was due to an expiration (because if we invoked cache.del(),
     * then we would have deleted the original key before deleting the expiring key).
     * Otherwise, the deletion is due to a manual call to cache.del().
     */
    TtlCache.prototype._setExpirationCallback = function (onExpiration) {
        var _this = this;
        this.cache.on('del', function (key) {
            if (isExpiringKey(key)) {
                var originalKey = getOriginalKey(key);
                var originalKeyValue = _this.cache.get(originalKey);
                if (!lodash_1.default.isUndefined(originalKeyValue)) {
                    // this 'del' was caused by an expiration
                    _this.cache.del(originalKey);
                    onExpiration(originalKey);
                }
            }
        });
    };
    return TtlCache;
}());
exports.TtlCache = TtlCache;
(function (angularModule) {
    angularModule.factory('pr.ttlCacheFactory', function () {
        return {
            createCache: function (options) {
                return new TtlCache(options);
            }
        };
    });
})(angular_1.module('qualtrics.pr'));
